import { makeStyles } from '@material-ui/core'
import { mq } from '@velocity/styling'

import type { Theme } from '@material-ui/core'

export type Props = { row: boolean | undefined }

export const useServicesFieldStyles = makeStyles<Theme, Props>(() => ({
  checkboxCardGroup: ({ row }: Props) => ({
    '&&': {
      width: 'auto',
      margin: 'calc(calc(var(--vel-fixed-spacing-05) / 2) * -1)',
      ...(row
        ? {
            [mq.min('LG')]: {
              gap: 'var(--vel-layout-spacing-06)',
              display: 'grid',
              gridAutoFlow: 'column',
              gridAutoColumns: '1fr',
              margin: 0,
            },
          }
        : {}),
    },
    '&& > div': {
      [mq.min('LG')]: {
        padding: row ? 0 : 'auto',
      },
      padding: 'calc(var(--vel-fixed-spacing-05) / 2)',
      width: '100%',
      '& label': {
        width: '100%',
      },
    },
    padding: 'auto',
    width: '100%',
    '& label': {
      width: '100%',
    },
  }),
  expanded: {
    borderRadius: 'var(--vel-shape300-border_radius)',
    border: '1px solid var(--vel-color-neutral-300)',
    background: 'var(--vel-color-neutral-white)',
    '& label': {
      border: '0 !important',
      background: 'transparent !important',
      boxShadow: 'none !important',
    },
    '& label::before': {
      boxShadow: 'none !important',
    },
    '&:has(label:hover)': {
      borderColor: 'var(--vel-color-neutral-600)',
    },
    '&:has(label input:focus)': {
      boxShadow:
        '0 0 0 2px var(--vel-color-misc-focused) inset, 0 0 0 2px var(--vel-color-neutral-white)',
    },
  },
  expandedContent: {
    margin: '0 var(--vel-fixed-spacing-05)',
    padding: 'var(--vel-fixed-spacing-05) 0',
    borderTop: '1px solid var(--vel-color-neutral-300)',
  },
}))
